import sizes from "../styles/_default.sizes.module.scss"

/**
 * Retourne l'image de bannière adaptée à la largeur de l'écran
 * @param {Number} width
 * @param {Object} images
 */
export const getBannerSrc = (width, images) => {
    if (width > parseInt(sizes.mediumScreenWidth)) {
        return images.src1280To1500
    } else if (width > parseInt(sizes.smallScreenWidth)) {
        return images.src1024To1280
    } else if (width > parseInt(sizes.mobileWidth)) {
        return images.src768To1024
    } else if (width > parseInt(sizes.smallMobileWidth)) {
        return images.src480To768
    } else {
        return images.src320To480
    }
}
